import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Recording/Snapshot_Schedule/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import ScheduleTable from 'components/Web_User_Interface/1440p_Series/Recording/Snapshot_Schedule/photoSheduleTable';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Aufgaben Menü // Snapshot Zeitplan",
  "path": "/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Snapshot_Schedule/",
  "dateChanged": "2024-09-19",
  "author": "Mike Polinowski",
  "excerpt": "Legen Sie einen Zeitplan für die Aufnahme von Schnappschüssen für bestimmte Wochentage und Tageszeiten fest. Speichern Sie diese Schnappschüsse auf der internen SD-Karte, versenden Sie sie per E-Mail oder laden Sie sie auf einen FTP-Server hoch.",
  "image": "./WebUI_1440p_SearchThumb_Tasks_Snapshot_Schedule.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Tasks_Snapshot_Schedule.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title="Aufgaben Menü // Snapshot Zeitplan" dateChanged="2024-09-19" author="Mike Polinowski" tag="INSTAR IP Camera" description="Legen Sie einen Zeitplan für die Aufnahme von Schnappschüssen für bestimmte Wochentage und Tageszeiten fest. Speichern Sie diese Schnappschüsse auf der internen SD-Karte, versenden Sie sie per E-Mail oder laden Sie sie auf einen FTP-Server hoch." image="/images/Search/WebUI_1440p_SearchThumb_Tasks_Snapshot_Schedule.png" twitter="/images/Search/WebUI_1440p_SearchThumb_Tasks_Snapshot_Schedule.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationDE="/de/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Snapshot_Zeitplan/" locationFR="/fr/Web_User_Interface/1440p_Series/Recording/Snapshot_Schedule/" crumbLabel="Video" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "aufgaben-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#aufgaben-men%C3%BC",
        "aria-label": "aufgaben menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufgaben Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "konfigurieren-sie-einen-zeitplan-für-schnappschussaufnahmen-auf-sd-karte-per-e-mail-oder-für-ftp-server",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfigurieren-sie-einen-zeitplan-f%C3%BCr-schnappschussaufnahmen-auf-sd-karte-per-e-mail-oder-f%C3%BCr-ftp-server",
        "aria-label": "konfigurieren sie einen zeitplan für schnappschussaufnahmen auf sd karte per e mail oder für ftp server permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfigurieren Sie einen Zeitplan für Schnappschussaufnahmen auf SD-Karte, per E-Mail oder für FTP-Server`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/310b1befc469409d473834eb6eca5c87/47aef/1440p_Settings_Task_Snap_Schedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACU0lEQVQoz2WQWU8TARRG+RfySBS6MCyJpRWknc5M22k7nTJbZ2mBKC5EEQSCC2oiEkgKBjVRUTCGQjAxxIUnE59981cd7ajpgw8n370vJ9+9XYIgIAwMEIucY7w6g373GOXWHvn5faS5PbI3/6d4+x3a8nsGUzLlYoGenh66u8+E2dXf348gDBDpPYtsXWH6yUf8By2CR0e4q4fUVlvU2nm/hXPvICR42GJ67QPjOYNsRmRwYBihf5B4XPgnFIhEolwcTWHpKmZFxZkoYVYK4d6enWqRSddgOrBxTQ1Ty6GXLCQxhyzlUWSV5MgFusKTQ2GEdCZDvTGFH9Tx/Dp+0MD1fCzbwa65uF6A5/m4wSTO1CwN00UrKciSgpjJkTif+tOwTShMp6nValiWheM4IbZth3sbwzCo6jq66WA0bjA3o+G7EmJaIivmOg3bwr6+PjKiyPLyEgsLC7iuG8o8z/uLj67rqIUCiiyjlTUWZ0sYWgZJlCgoCslkqnNyW5gVs2w3t9je3qbRaOA4NvV6QOB7BK6NUdUoV3WKE1V0w2R/dR63oiBnRdS8wshIstMw0hshraSpXKpQKpawLBPTssNWmneViaVdqvM7rFUc9vMlFstVjjbWWapp4e8VKUcikez8MBaNMTQ8xGh6lEKuSE5RKalFrtcN3m6u8On4kNe7B3zZe8nnnSan7dx9yvrlMmpeJisqjCRSnYbxeJxoNEosEmNsTESVZWZslcfXLE62Vvj57Zgf37+y/6LJq+YGp2+ec/JskzteHs9UyaRlEr+FvwC3hoPZdMjB+QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/310b1befc469409d473834eb6eca5c87/e4706/1440p_Settings_Task_Snap_Schedule.avif 230w", "/de/static/310b1befc469409d473834eb6eca5c87/d1af7/1440p_Settings_Task_Snap_Schedule.avif 460w", "/de/static/310b1befc469409d473834eb6eca5c87/7f308/1440p_Settings_Task_Snap_Schedule.avif 920w", "/de/static/310b1befc469409d473834eb6eca5c87/29832/1440p_Settings_Task_Snap_Schedule.avif 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/310b1befc469409d473834eb6eca5c87/a0b58/1440p_Settings_Task_Snap_Schedule.webp 230w", "/de/static/310b1befc469409d473834eb6eca5c87/bc10c/1440p_Settings_Task_Snap_Schedule.webp 460w", "/de/static/310b1befc469409d473834eb6eca5c87/966d8/1440p_Settings_Task_Snap_Schedule.webp 920w", "/de/static/310b1befc469409d473834eb6eca5c87/0ca5b/1440p_Settings_Task_Snap_Schedule.webp 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/310b1befc469409d473834eb6eca5c87/81c8e/1440p_Settings_Task_Snap_Schedule.png 230w", "/de/static/310b1befc469409d473834eb6eca5c87/08a84/1440p_Settings_Task_Snap_Schedule.png 460w", "/de/static/310b1befc469409d473834eb6eca5c87/c0255/1440p_Settings_Task_Snap_Schedule.png 920w", "/de/static/310b1befc469409d473834eb6eca5c87/47aef/1440p_Settings_Task_Snap_Schedule.png 1063w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/310b1befc469409d473834eb6eca5c87/c0255/1440p_Settings_Task_Snap_Schedule.png",
              "alt": "Web User Interface - 1440p Series - Recording",
              "title": "Web User Interface - 1440p Series - Recording",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ScheduleTable mdxType="ScheduleTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      